import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaUtensils, FaCheckCircle, FaClock, FaTable } from 'react-icons/fa';
import { getPendingOrders, getOrders, updateOrderStatus } from '../utils/dataStore';
import './RestaurantDashboard.css';

function RestaurantDashboard() {
  const [orders, setOrders] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [viewMode, setViewMode] = useState('pending'); // 'pending' or 'all'

  useEffect(() => {
    loadOrders();
    const interval = setInterval(loadOrders, 3000); // Refresh every 3 seconds
    return () => clearInterval(interval);
  }, [viewMode]);

  const loadOrders = () => {
    const allOrders = viewMode === 'pending' ? getPendingOrders() : getOrders();
    setOrders(allOrders);
  };

  const handleConfirmOrder = (orderId) => {
    updateOrderStatus(orderId, 'confirmed');
    loadOrders();
  };

  const handleCompleteOrder = (orderId) => {
    updateOrderStatus(orderId, 'completed');
    loadOrders();
  };

  const groupedOrders = orders.reduce((acc, order) => {
    const table = order.tableNumber;
    if (!acc[table]) {
      acc[table] = [];
    }
    acc[table].push(order);
    return acc;
  }, {});

  const tables = Object.keys(groupedOrders).sort((a, b) => parseInt(a) - parseInt(b));

  return (
    <div className="restaurant-dashboard">
      <header className="dashboard-header">
        <h1 className="dashboard-title">
          <FaUtensils className="title-icon" />
          Restaurant Dashboard
        </h1>
        <div className="dashboard-controls">
          <button
            className={`view-mode-btn ${viewMode === 'pending' ? 'active' : ''}`}
            onClick={() => setViewMode('pending')}
          >
            <FaClock /> Pending
          </button>
          <button
            className={`view-mode-btn ${viewMode === 'all' ? 'active' : ''}`}
            onClick={() => setViewMode('all')}
          >
            All Orders
          </button>
          <Link to="/restaurant/menu" className="menu-management-btn">
            <FaUtensils /> Manage Menu
          </Link>
        </div>
      </header>

      <div className="dashboard-content">
        {tables.length === 0 ? (
          <div className="no-orders">
            <FaTable className="no-orders-icon" />
            <p>No {viewMode === 'pending' ? 'pending' : ''} orders</p>
          </div>
        ) : (
          <div className="tables-grid">
            {tables.map(table => (
              <div key={table} className="table-card">
                <div className="table-header">
                  <FaTable className="table-icon" />
                  <h2 className="table-number">Table {table}</h2>
                  <span className="order-count">{groupedOrders[table].length} order(s)</span>
                </div>
                <div className="table-orders">
                  {groupedOrders[table].map(order => (
                    <div key={order.id} className="order-item">
                      <div className="order-info">
                        <div className="order-dish">
                          <img 
                            src={order.dish?.image || 'https://via.placeholder.com/50'} 
                            alt={order.dish?.name}
                            className="order-dish-image"
                          />
                          <div className="order-dish-details">
                            <h4 className="order-dish-name">{order.dish?.name || 'Unknown'}</h4>
                            <p className="order-customer">
                              {order.name} • {order.mobile}
                            </p>
                          </div>
                        </div>
                        <div className="order-status">
                          <span className={`status-badge ${order.status}`}>
                            {order.status}
                          </span>
                        </div>
                      </div>
                      <div className="order-actions">
                        {order.status === 'pending' && (
                          <button
                            className="confirm-btn"
                            onClick={() => handleConfirmOrder(order.id)}
                          >
                            <FaCheckCircle /> Confirm
                          </button>
                        )}
                        {order.status === 'confirmed' && (
                          <button
                            className="complete-btn"
                            onClick={() => handleCompleteOrder(order.id)}
                          >
                            Complete
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default RestaurantDashboard;

